import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ArticleSection from './components/ArticleSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "GTBuy Spreadsheet Intelligence Engine",
  "url": "https://gtbuy.art/",
  "description": "GTBuy.art is a product comparison search engine powered by structured spreadsheet data. Compare 5000+ products across Kakobuy, Superbuy, and GTBuy systems instantly.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://kaspreadsheet.com/search-{category_id}/name/Shoes.html"
    },
    "query-input": "required name=category_id"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ArticleSection />
        <CategoryGrid />
        <FeatureGrid />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}